export default __webpack_public_path__ + "static/portfolio-1-ed003722d4160dfc3ea9c793164ed201.jpg";